export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-gray-50 to-red-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Sobre a <span className="text-red-600">IchiBan</span>
            <br />
            <span className="text-lg text-red-700 font-normal italic">"Honra, Disciplina e Excelência"</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Somos uma agência que atua no mercado de marketing digital para todos os tipos de negócios, utilizando Inteligência Artificial como suporte para diversas operações nas campanhas e estratégias digitais, com foco em Growth Marketing como estratégia de crescimento dos resultados das empresas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="flex items-center mb-6">
              <div className="bg-red-100 p-3 rounded-full mr-4 w-12 h-12 flex items-center justify-center">
                <i className="ri-flag-line text-red-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Missão</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">
              Capacitar negócios de todos os tipos a prosperar no ambiente digital, oferecendo soluções inovadoras de Growth Marketing com suporte de Inteligência Artificial para operações e campanhas digitais, executadas por uma equipe sem fronteiras de especialistas apaixonados e altamente engajados.
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="flex items-center mb-6">
              <div className="bg-red-100 p-3 rounded-full mr-4 w-12 h-12 flex items-center justify-center">
                <i className="ri-eye-line text-red-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Visão</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">
              Ser a agência líder e mais inspiradora em Growth Marketing com suporte de Inteligência Artificial, reconhecida por atender todos os tipos de negócios com estratégias digitais inovadoras e pela capacidade de gerar crescimento exponencial dos resultados das empresas.
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="flex items-center mb-6">
              <div className="bg-red-100 p-3 rounded-full mr-4 w-12 h-12 flex items-center justify-center">
                <i className="ri-heart-line text-red-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Valores</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">
              Liberdade e flexibilidade, paixão por resultados, excelência e inovação, colaboração sem fronteiras, comprometimento e responsabilidade, adaptabilidade e resiliência.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
            <div className="flex items-center mb-4">
              <i className="ri-flight-takeoff-line text-red-600 text-2xl mr-3"></i>
              <h4 className="font-semibold text-gray-900">Liberdade e Flexibilidade</h4>
            </div>
            <p className="text-gray-600 text-sm">
              Trabalhe de qualquer lugar do mundo com autonomia total para criar e inovar.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
            <div className="flex items-center mb-4">
              <i className="ri-fire-line text-red-600 text-2xl mr-3"></i>
              <h4 className="font-semibold text-gray-900">Paixão por Resultados</h4>
            </div>
            <p className="text-gray-600 text-sm">
              Obsessão por entregar resultados excepcionais que superem as expectativas.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
            <div className="flex items-center mb-4">
              <i className="ri-team-line text-red-600 text-2xl mr-3"></i>
              <h4 className="font-semibold text-gray-900">Colaboração Sem Fronteiras</h4>
            </div>
            <p className="text-gray-600 text-sm">
              Diversidade e troca de conhecimentos de talentos de diferentes culturas.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-red-600 to-red-500 rounded-3xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl md:text-4xl font-bold mb-6">Cultura de Trabalho Remoto</h3>
          <p className="text-xl mb-8 max-w-4xl mx-auto leading-relaxed">
            Nossa equipe pode operar de qualquer lugar: seja de uma cafeteria em Paris, praias no Brasil, coworkings em Tóquio ou escritórios em casa. O que importa é a qualidade do trabalho e a paixão por resultados. Acreditamos que a liberdade geográfica potencializa a criatividade e a produtividade.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-2xl font-bold mb-2">🌍</div>
              <div className="text-sm">Sem Fronteiras</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold mb-2">☕</div>
              <div className="text-sm">Cafeterias</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold mb-2">🏖️</div>
              <div className="text-sm">Praias</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold mb-2">🏠</div>
              <div className="text-sm">Home Office</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
